<template>
  <div class="page_background">
    <div class="head-title">{{ $t('feedback_page.title') }}</div>
    <new-glas-card :title="$t('feedback_page.headline_efh')">
      <v-row>
        <v-col>
          <feedback-dashboard />
        </v-col>
        <v-col>
          <h3 class="center">PLATZHALTER</h3>
        </v-col>
      </v-row>
      <div class="center">
        <v-btn class="drop-down" v-if="showTable" @click="showTable= !showTable" text>Details <v-icon>mdi-chevron-up</v-icon> </v-btn>
        <v-btn class="drop-down" v-else @click="showTable= !showTable" text>Details <v-icon>mdi-chevron-down</v-icon> </v-btn>
      </div>
      <feedback-table-component v-show="showTable" />
    </new-glas-card>
  </div>
</template>


<script>
  import NewGlasCard from '@bit/new-netzportal.netzportal.new-glas-card';
  import FeedbackTableComponent from "../components/feedback-component/FeedbackTableComponent";
  import FeedbackDashboard from "../components/feedback-component/FeedbackDashboard";
  //import { getRatingsGraphQl } from "../services/RatingService"
  import { getOrdersGraphQl } from '../services/OrderService';
  //import {feedbacks } from '../components/feedback-component/MockFeedbacks';
  import { getFeedbacksWithFilter } from '../services/RatingService';

  export default {
    name: "HomePage",
    components: {
      FeedbackDashboard,
      FeedbackTableComponent,
      NewGlasCard
    },
    created() {
      this.getOrdersFromBackend()
      this.getFeedbacksWithFilter()
    },
    methods: {
      getOrdersFromBackend() {
        let  params = { 
          limit: 20, 
          from_index: this.orders.length
        }
        getOrdersGraphQl(params).then(res => {
          this.orders = res.data.data.listOrders.items
          this.$store.commit('setOrders', this.orders);
          this.devDataLoading = false;
        }).catch(err => {
          console.log(err);
        })   
      },
      getFeedbacksWithFilter(){
        let params = {
          limit: 20, 
          filter: 'all',
          from_index: this.ratings ? this.ratings.length : 0,
          search_word: ''
        }

          getFeedbacksWithFilter(params).then(res => {
            if(res.data.data.getFeedbacksWithFilter) {
              this.ratings = this.ratings.concat(res.data.data.getFeedbacksWithFilter.items);
            }
            if(this.ratings.length === res.data.data.getFeedbacksWithFilter.count_feedbacks){
              this.$store.commit('setRatings', this.ratings);
            } else {
              this.getFeedbacksWithFilter();      
            }
          }).catch(err => {
            console.log(err);
          })
        
      }
    },
    data() {
      return {
        showTable: false,
        orders: [],
        ratings: []
      }
    }
  }
</script>

<style scoped>
.head-title {
  font-size: 60px;
  margin-bottom: 37px;
  margin-top: 89px;
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.drop-down {
  color: white;
  font-weight: bold;
}
</style>
